import {useItemsDashboard} from '@kit';

import React from 'react';

import {Layout} from '../../components/layout';
import {useFilters} from '../../components/filters';
import {NotFoundSeo, SectionSeo} from '../../lib/seo';
import {Monster, useMonstersQuery} from '../../generated/types';
import {getApolloError, uppercaseFirstLetter, normalizeRuStr, cls} from '../../components/utils';
import {useRoute} from '../../lib/routes';
import {MonsterLayout} from './layout';
import {getAllTitles, getCr, toMonsterTypeString} from '../../components/render-helpers';
import {MonsterFilters, monsterFilters} from './filters';

import css from '@kit/sidebar/dashboard.module.css';
import pageCss from '../../components/common.module.css';

export const MonstersPage: React.FC = () => {
	const filters = useFilters(monsterFilters);

	const {data, loading, error} = useMonstersQuery({
		ssr: true,
		variables: {filters: filters.values},
	});

	const router = useRoute();
	const query = router?.query || {};

	const {selectedId, selected, showView, handleBack, Sidebar, notFound} = useItemsDashboard({
		items: data?.monsters || [],
		id: query.id as string,
		loading,
		route: 'monster',
		baseRoute: 'monsters',
		filterFn: (monster, str) => {
			const names = getAllTitles(monster as Monster);
			return names.some((name) => normalizeRuStr(name).includes(normalizeRuStr(str)));
		},
		sidebarHeader: (monster) => monster.title || '',
		sidebarSecondary: (monster) =>
			`${uppercaseFirstLetter(toMonsterTypeString(monster.types, monster.swarmSize))}${
				monster.cr ? ` · КО ${getCr(monster.cr)}` : ''
			}`,
		onOpenFilters: filters.toggle,
		isFiltersSet: filters.isSet,
	});

	const title = showView && selected ? selected.title : 'Чудовища';

	return (
		<Layout handleBack={selected && handleBack}>
			{!selectedId && <SectionSeo section="monsters" />}
			{notFound && <NotFoundSeo />}
			<MonsterFilters filters={filters} />
			<div className={css.dashboard}>
				{error ? (
					<div className={pageCss.fullSizeBlock}>{getApolloError(error).message}</div>
				) : (
					<div className={cls(css.dashboardWrapper, showView && css.showView)}>
						<div className={css.sidebar}>{Sidebar}</div>
						<div className={css.view}>
							{selectedId && showView ? (
								<MonsterLayout monsterId={selectedId} title={title || ''} />
							) : (
								<div className={pageCss.fullSizeBlock}>Выберите чудовище</div>
							)}
						</div>
					</div>
				)}
			</div>
		</Layout>
	);
};
